import {
  localize
} from 'b2b-common/vue-config/vee-validate'
import ro from 'vee-validate/dist/locale/ro.json'

localize('ro', ro)
